module.exports = __webpack_public_path__ + "static/media/ms.e147bd2b.svg";